import NavNative from '../NavNative';
// import AskToSignInPage from '../AskToSignInPage';
import IntroPostSignInOrNot from './IntroPostSignInOrNot';
import React, {useEffect, useRef, useState} from 'react';

function App(props) {

  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var tryConnect = props.tryConnect;
  var height = props.height;
  var width = props.width;
  var history = props.history;
  var sortBy = props.sortBy;
  var setSortBy = props.setSortBy;
  var justLoadHistory = props.justLoadHistory;
  var addToExtraScreen = props.addToExtraScreen;
  var logInState = props.logInState;
  var logOut = props.logOut;
  var nosCredits = props.nosCredits;
  var isShowingPrevious = props.isShowingPrevious;
  var setIsShowingPrevious = props.setIsShowingPrevious;
  var selectNew = props.selectNew;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var chains = props.chains;
  var clickBack = props.clickBack;
  
  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var palette = props.palette;
  var changeTab = props.changeTab;


  const [timeToggle, setTimeToggle] = useState(0);
  
  useEffect(() => {
      setDoingWhat(false);
  }, [history])

  var ref1 = useRef();


  function onScroll(e){
    setTimeToggle(1 - timeToggle);
  }

  var details;


  if (doingWhat && doingWhat.t === 'newDapp'){
    details = <div><br/><br/><p className="lead mb-0">Creating dApp...</p></div>
  }else{

    var scrollAmt = 0;
    if (ref1 && ref1.current){
      scrollAmt = ref1.current.scrollTop;
    }

    details = <IntroPostSignInOrNot chains={chains} userID={userID} sessionID={sessionID} signKey={signKey} tryConnect={tryConnect} history={history} sortBy={sortBy} setSortBy={setSortBy} justLoadHistory={justLoadHistory}  isShowingPrevious={isShowingPrevious} setIsShowingPrevious={setIsShowingPrevious} selectNew={selectNew} doingWhat={doingWhat} setDoingWhat={setDoingWhat} width={width} height={height} addToExtraScreen={addToExtraScreen} scrollAmt={scrollAmt} logInState={logInState} clickBack={clickBack} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} palette={palette} changeTab={changeTab}/>
  }


    return <div onScroll={onScroll} style={{height, overflow:'scroll', textAlign:'center', position:'relative'}} ref={ref1}>
      <NavNative revertProgramIDFn={clickBack} logInState={logInState} addToExtraScreen={addToExtraScreen} logOut={logOut} nosCredits={nosCredits} history={history}/>
      {details}
      </div>


//
//
}

export default App;
